module.exports = __webpack_public_path__ + "img/03.7c7ac810.jpg";